import { render, staticRenderFns } from "./InformationManagement.vue?vue&type=template&id=16ed8efa&scoped=true"
import script from "./InformationManagement.vue?vue&type=script&lang=js"
export * from "./InformationManagement.vue?vue&type=script&lang=js"
import style0 from "./InformationManagement.vue?vue&type=style&index=0&id=16ed8efa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ed8efa",
  null
  
)

export default component.exports